// Traducciones en español para la sección de cancelación de suscripción
const unsubscribe = {
  title: "Cancelar suscripción",
  noEmail: "No se proporcionó el correo. No se pudo dar de baja.",
  success: "Te has dado de baja correctamente.",
  error: "Hubo un error al procesar tu solicitud de baja.",
  buttonBack: "Volver al inicio"
}; 

export default unsubscribe; 